module.exports = __webpack_public_path__ + "static/media/poster7.cbff037a.png";